import { getAuthorizationHeader } from '@/services/auth';

export const openCSVLink = (link: string) => {
    window.open(link, "_blank");
}

/**
 * Calls an authenticated endpoint that returns `{ url: string }` (a
 * short-lived signed object URL), then navigates the browser to it via
 * `window.location.href`.
 *
 * Direct navigation is used intentionally: the signed URL is public (no auth
 * header needed) and CORS does not apply to plain browser navigations, so the
 * file download starts without CORS issues.
 *
 * @returns true on success, false on failure (caller shows the error toast).
 */
export const fetchSignedUrlAndNavigate = async (
  endpointUrl: string,
): Promise<boolean> => {
  try {
    const response = await fetch(endpointUrl, {
      method: 'GET',
      headers: { ...getAuthorizationHeader() },
    });

    if (!response.ok) {
      return false;
    }

    const data = await response.json();
    if (!data?.url) {
      return false;
    }

    window.location.href = data.url;
    return true;
  } catch (e) {
    return false;
  }
};
